import axios from './axiosService';

/**
 * MLD-4012
 * MLD-6390
 */
export default {
  useOOP(templateID) {
    return axios.post(`/api/share-templates/${templateID}/check-spam/oop`)
      .then(response => response.data);
  },
  usePM(templateID) {
    return axios.post(`/api/share-templates/${templateID}/check-spam/pm`)
      .then(response => response.data);
  },
  useSC(templateID) {
    return axios.post(`/api/share-templates/${templateID}/check-spam/sc`)
      .then(response => response.data);
  },
}
